import React, { useEffect, useState, useRef } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../components/ModalsCommonFunctions';
import { CModal } from '@coreui/react';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import Pagination from '../components/Pagination';
import { generateAxiosInstanceSection } from '../hooks/useAuthorizedRequestForSection';
import ReactPlayer from 'react-player';
import ViewImageAndText from '../components/ViewImageAndText';

const DashboardQuestionBank = () => {
    const authorizedAxios = generateAxiosInstance()

    const [activeTab, setActiveTab] = useState("textBook");
    const [visible, setVisible] = useState(false);
    const [visibleImage, setVisibleImage] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');
    const [modalData, setModalData] = useState("")


    const [textBookList, setTextBookList] = useState([]);
    const [competitiveList, setCompetitiveList] = useState([]);

    const [startIndexTextBook, setStartIndexTextBook] = useState(null);
    const [startIndexCompetitive, setStartIndexCompetitive] = useState(null);

    const [currPageTextBook, setCurrPageTextBook] = useState(1);
    const [currPageCompetitive, setCurrPageCompetitive] = useState(1);

    const [itemsPerPageTextBook, setItemsPerPageTextBook] = useState(10);
    const [itemsPerPageCompetitive, setItemsPerPageCompetitive] = useState(10);

    const [displayedDataTextBook, setDisplayedDataTextBook] = useState([]);
    const [displayedDataCompetitive, setDisplayedDataCompetitive] = useState([]);

    const [totalPagesTextBook, setTotalPagesTextBook] = useState(0);
    const [totalPagesCompetitive, setTotalPagesCompetitive] = useState(0);


    const [textBookQuestionLevelSort, setTextBookQuestionLevelSort] = useState(null);
    const [textBookQuestionTypeSort, setTextBookQuestionTypeSort] = useState(null);
    const [textBookQuestionSort, setTextBookQuestionSort] = useState(null);

    const [competitiveQuestionLevelSort, setCompetitiveQuestionLevelSort] = useState(null);
    const [competitiveQuestionTypeSort, setCompetitiveQuestionTypeSort] = useState(null);
    const [competitiveQuestionSort, setCompetitiveQuestionSort] = useState(null);

    const [searchValueTextBook, setSearchValueTextBook] = useState(null);
    const [searchValueCompetitive, setSearchValueCompetitive] = useState(null);

    const searchKey = ["q_level", "q_type", "question", "option_a", "option_b", "option_c", "option_d", "ans"];
    // const searchKey = ["q_level", "q_type", "question", "option_a", "option_b", "option_c", "option_d", "ans"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    const onViewImage = (imgSrc) => {
        setModalImageSrc(imgSrc);
        setVisibleImage(true);
    };

    useEffect(() => {
        getTextBookQuestions();
        getCompetitiveQuestions();
    }, [])

    const getApiUrlTextBook = () => {
        return `/get-dashboard-text-book-question`;
    }

    const getApiUrlCompetitive = () => {
        return `/get-dashboard-competitive-question`;
    }


    const getTextBookQuestions = async () => {
        try {
            setLoading(true);
            const apiUrl = getApiUrlTextBook();
            const response = await authorizedAxios.get(apiUrl);
            setTextBookList(response.data.result);
        } catch (error) {
            setTextBookList(error?.data?.result || []);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }

    const getCompetitiveQuestions = async () => {
        try {
            setLoading(true);
            const apiUrl = getApiUrlCompetitive();
            const response = await authorizedAxios.get(apiUrl);
            setCompetitiveList(response.data.result);
        } catch (error) {
            setCompetitiveList(error?.data?.result || []);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        if (searchValueTextBook === '' && searchValueTextBook !== null) {
            setCurrPageTextBook(1);
            getTextBookQuestions();
        }
    }, [searchValueTextBook]);

    useEffect(() => {
        if (searchValueCompetitive === '' && searchValueCompetitive !== null) {
            setCurrPageCompetitive(1);
            getCompetitiveQuestions();
        }
    }, [searchValueCompetitive]);



    const handleEmptySearchTextBook = (e) => {
        setSearchValueTextBook(e.target.value);
    }

    const handleEmptySearchCompetitive = (e) => {
        setSearchValueCompetitive(e.target.value);
    }


    const handleSearchTextBook = async () => {
        if (searchValueTextBook !== null) {
            setCurrPageTextBook(1);
            setTextBookList(await searchArray("A", getApiUrlTextBook(), searchKey, searchValueTextBook.trim()));
        }
    }

    const handleSearchCompetitive = async () => {
        if (searchValueCompetitive !== null) {
            setCurrPageCompetitive(1);
            setCompetitiveList(await searchArray("A", getApiUrlCompetitive(), searchKey, searchValueCompetitive.trim()));
        }
    }


    useEffect(() => {
        setTotalPagesTextBook(Math.ceil(textBookList.length / itemsPerPageTextBook));
        const startIndexTextBook = (currPageTextBook - 1) * itemsPerPageTextBook;
        let endIndexPdf = startIndexTextBook + itemsPerPageTextBook;

        if (endIndexPdf > textBookList.length) {
            endIndexPdf = textBookList.length;
        }
        setStartIndexTextBook(startIndexTextBook);
        setDisplayedDataTextBook(textBookList.slice(startIndexTextBook, endIndexPdf));
    }, [textBookList, currPageTextBook, itemsPerPageTextBook]);

    useEffect(() => {
        setTotalPagesCompetitive(Math.ceil(competitiveList.length / itemsPerPageCompetitive));
        const startIndexCompetitive = (currPageCompetitive - 1) * itemsPerPageCompetitive;
        let endIndexReference = startIndexCompetitive + itemsPerPageCompetitive;

        if (endIndexReference > competitiveList.length) {
            endIndexReference = competitiveList.length;
        }
        setStartIndexCompetitive(startIndexCompetitive);
        setDisplayedDataCompetitive(competitiveList.slice(startIndexCompetitive, endIndexReference));
    }, [competitiveList, currPageCompetitive, itemsPerPageCompetitive])



    useEffect(() => {
        if (textBookQuestionLevelSort == true || textBookQuestionLevelSort == false) {
            setTextBookQuestionTypeSort(null);
            setTextBookQuestionSort(null);
        }
    }, [textBookQuestionLevelSort])

    useEffect(() => {
        if (textBookQuestionTypeSort == true || textBookQuestionTypeSort == false) {
            setTextBookQuestionLevelSort(null);
            setTextBookQuestionSort(null);
        }
    }, [textBookQuestionTypeSort])

    useEffect(() => {
        if (textBookQuestionSort == true || textBookQuestionSort == false) {
            setTextBookQuestionLevelSort(null);
            setTextBookQuestionTypeSort(null);
        }
    }, [textBookQuestionSort])



    useEffect(() => {
        if (competitiveQuestionLevelSort == true || competitiveQuestionLevelSort == false) {
            setCompetitiveQuestionTypeSort(null);
            setCompetitiveQuestionSort(null);
        }
    }, [competitiveQuestionLevelSort])

    useEffect(() => {
        if (competitiveQuestionTypeSort == true || competitiveQuestionTypeSort == false) {
            setCompetitiveQuestionLevelSort(null);
            setCompetitiveQuestionSort(null);
        }
    }, [competitiveQuestionTypeSort])

    useEffect(() => {
        if (competitiveQuestionSort == true || competitiveQuestionSort == false) {
            setCompetitiveQuestionLevelSort(null);
            setCompetitiveQuestionTypeSort(null);
        }
    }, [competitiveQuestionSort])


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Question Bank</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-users-line"></i>Question Bank</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="d-grid gap-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <button className={`${activeTab === "textBook" ? "active" : ""} btn btn-light btn-width`} onClick={() => setActiveTab("textBook")} >Text Book</button>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <button className={`${activeTab === "competitive" ? "active" : ""} btn btn-light btn-width`} onClick={() => setActiveTab("competitive")} >Competitive</button>
                                                            </div>
                                                        </div>

                                                        {activeTab == "textBook" &&
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <div className='search_btn_row mb-2'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValueTextBook}
                                                                        onChange={handleEmptySearchTextBook}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearchTextBook();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearchTextBook}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div>
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope='col'>
                                                                                Q_Level
                                                                                <SortIcon sortState={textBookQuestionLevelSort} setSortState={setTextBookQuestionLevelSort} setData={setTextBookList} setCurrPage={setCurrPageTextBook} sortingPath={"q_level"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Q_Type
                                                                                <SortIcon sortState={textBookQuestionTypeSort} setSortState={setTextBookQuestionTypeSort} setData={setTextBookList} setCurrPage={setCurrPageTextBook} sortingPath={"q_type"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Question
                                                                                <SortIcon sortState={textBookQuestionSort} setSortState={setTextBookQuestionSort} setData={setTextBookList} setCurrPage={setCurrPageTextBook} sortingPath={"question"} />
                                                                            </th>
                                                                            <th scope="col">Option_a</th>
                                                                            <th scope="col">Option_b </th>
                                                                            <th scope="col">Option_c</th>
                                                                            <th scope="col">Option_d</th>
                                                                            <th scope='col'>Answer</th>
                                                                            <th scope='col'>Solution</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedDataTextBook?.length > 0 ?
                                                                                displayedDataTextBook?.map((question, index) => {
                                                                                    return (
                                                                                        <tr key={index}>
                                                                                            <th scope="row" className='sl_no'>{startIndexTextBook + index + 1}</th>
                                                                                            <td>{question.q_level}</td>
                                                                                            <td>{question.q_type}</td>
                                                                                            <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_a} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_b} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_c} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_d} onViewImage={onViewImage} />
                                                                                            <td>{question.ans}</td>
                                                                                            <td>
                                                                                                <button className="btn btn-primary view_icon mt-1" type="button" onClick={() => {
                                                                                                    setVisible(!visible)
                                                                                                    setModalData(question.sol)
                                                                                                }}><i class="fa fa-eye" ></i></button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPageTextBook} setCurrPage={setCurrPageTextBook} totalPages={totalPagesTextBook} itemsPerPage={itemsPerPageTextBook} setItemsPerPage={setItemsPerPageTextBook} totalItem={textBookList.length} />
                                                            </div>}

                                                        {activeTab == "competitive" &&
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <div className='search_btn_row mb-2'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValueCompetitive}
                                                                        onChange={handleEmptySearchCompetitive}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearchCompetitive();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearchCompetitive}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div>
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope='col'>
                                                                                Q_Level
                                                                                <SortIcon sortState={competitiveQuestionLevelSort} setSortState={setCompetitiveQuestionLevelSort} setData={setCompetitiveList} setCurrPage={setCurrPageCompetitive} sortingPath={"q_level"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Q_Type
                                                                                <SortIcon sortState={competitiveQuestionTypeSort} setSortState={setCompetitiveQuestionTypeSort} setData={setCompetitiveList} setCurrPage={setCurrPageCompetitive} sortingPath={"q_type"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Question
                                                                                <SortIcon sortState={competitiveQuestionSort} setSortState={setCompetitiveQuestionSort} setData={setCompetitiveList} setCurrPage={setCurrPageCompetitive} sortingPath={"question"} />
                                                                            </th>
                                                                            <th scope="col">Option_a</th>
                                                                            <th scope="col">Option_b </th>
                                                                            <th scope="col">Option_c</th>
                                                                            <th scope="col">Option_d</th>
                                                                            <th scope='col'>Answer</th>
                                                                            <th scope='col'>Solution</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedDataCompetitive?.length > 0 ?
                                                                                displayedDataCompetitive?.map((question, index) => {
                                                                                    return (
                                                                                        <tr key={index}>
                                                                                            <th scope="row" className='sl_no'>{startIndexCompetitive + index + 1}</th>
                                                                                            <td>{question.q_level}</td>
                                                                                            <td>{question.q_type}</td>
                                                                                            <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_a} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_b} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_c} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_d} onViewImage={onViewImage} />
                                                                                            <td>{question.ans}</td>
                                                                                            <td>
                                                                                                <button className="btn btn-primary view_icon mt-1" type="button" onClick={() => {
                                                                                                    setVisible(!visible)
                                                                                                    setModalData(question.sol)
                                                                                                }}><i class="fa fa-eye" ></i></button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPageCompetitive} setCurrPage={setCurrPageCompetitive} totalPages={totalPagesCompetitive} itemsPerPage={itemsPerPageCompetitive} setItemsPerPage={setItemsPerPageCompetitive} totalItem={competitiveList.length} />
                                                            </div>}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />


            {visible && <CModal
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="LiveDemoExampleLabel"
                onIni
            >
                <div className="book book-modal">
                    <h2 className='table-header-like'> Solution</h2>
                    <div className="page no-error-class" dangerouslySetInnerHTML={{
                        __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${modalData === null ? "No Solution Found" : modalData}</div>`
                    }}></div>

                    <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                        Close
                    </button>
                </div>
            </CModal>}

            {visibleImage && (
                <CModal
                    visible={visibleImage}
                    onClose={() => setVisibleImage(false)}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <div className="book book-modal">
                        <div className='table-header-like'>Image</div>
                        {modalImageSrc && <div className='page' dangerouslySetInnerHTML={{ __html: modalImageSrc }}></div>}
                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisibleImage(false)}>
                            Close
                        </button>
                    </div>
                </CModal>
            )}

        </>
    )
};

export default DashboardQuestionBank;